export const downloadVenuesTemplateCSV = async (): Promise<Blob> => {
  try {
    const uri = `https://openr-tooling-static-files-${
      process.env.REACT_APP_ENV ?? 'dev'
    }.s3.eu-west-1.amazonaws.com/Openr_venue_import.csv`;
    const res = await fetch(uri);
    if (!res.ok) throw new Error(res.statusText);
    return await res.blob();
  } catch (e) {
    throw new Error('Could not download venues template CSV', { cause: e });
  }
};
